export default "__VITE_ASSET__5l8jgIgM__"